import React from "react";

import { useTranslation } from "react-i18next";

import Button from '../Button'

import Fade from 'react-reveal/Fade'

import img from '../../img/Home/smart.png'

function SmartSmall () {

    const { t } = useTranslation();
    return(
        <div className="relative max-w-[1280px] xl:mx-auto mx-[20px] mt-[80px] xl:mt-[160px]">    
            <div className="flex flex-col xl:flex-row justify-between">
                <div className="xl:w-[488px] flex flex-col">
                    <p className="bebas text-[24px] xl:text-[48px]">{t('home.26')}</p>
                    <p className="helvetica text-[14px] xl:text-[16px] mt-[20px] xl:mt-[45px]">{t('home.27')}</p>
                    <Button className="mt-[45px] hidden xl:block mr-auto"/>  
                </div>
                <div className="mt-[20px] xl:mt-0">
                    <Fade right><img src={img} alt="" className="mx-auto"/></Fade>
                </div>
            </div>
        </div>
    );
}

export default SmartSmall;